import { FollowupVisitButton } from 'react-viewerbase';
import { connect } from 'react-redux';

const mapStateToProps = state => {
  return {
    currentLayout: state.viewports.layout,
  };
};

const ConnectedFollowupVisitButton = connect(
  mapStateToProps,
  null
)(FollowupVisitButton);

export default ConnectedFollowupVisitButton;
